<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Text format bold',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>

<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 18h5.2a3.6 3.6 0 1 0 0-7.2h.4a2.4 2.4 0 0 0 0-4.8H8m1.6 0v12m3.6-7.2H9.6"/>
  </svg>
</template>
